import React, {useEffect, useState} from 'react'
import { HStack, Text, Flex, Box, Slider, SliderTrack, SliderThumb } from "@chakra-ui/react";

import { t } from "@lang/i18n";


const AddressSlider = ({ setForm, form }) => {
    const [slider, setSlider] = useState(0);

    const sliderConfig = {
        min: 0,
        max: 101,
        step: 1
    };

    const setSliderValue = (val) => {
        setSlider(val);
        setForm({
            ...form, search_radius: val
        })
    };

    useEffect(() => {
        let value;
        
        if (!form.search_radius) return;
        else if (form.search_radius === 999) value = 101;
        else value = form.search_radius;

        setSlider(value);
    }, []);

    return(
        <Flex flexDir="column" justifyContent="center" opacity=".8" py="1rem" w={["80vw", "", "385px"]}>
            <HStack justifyContent="space-between">
                <Text fontSize="12px" textColor="black" mb=".5rem"> 
                    {t('candidate.profile.edit.rayon_search')} en 
                    <Box as="span" fontSize="15px" fontWeight="bold"> (Km) </Box> 
                </Text>
            </HStack>

            <Slider colorScheme="blue" defaultValue={slider}
                    min={sliderConfig.min} 
                    max={sliderConfig.max} 
                    step={sliderConfig.step} value={slider}
                    onChange={(val) => setSliderValue(val)}
                    >
                <SliderTrack h="4px" w={["80vw", "", "385px"]}>
                </SliderTrack>
                <SliderThumb bg="blue.light" boxShadow="0px 1px 6px rgba(0, 0, 0, 0.5)" w="35px" h="35px" color="white" fontSize=".75rem">
                    {slider === 101 || slider === 999 ? "+100" : slider}
                </SliderThumb>
            </Slider>
        </Flex>
    )
}

export default AddressSlider;